import React from "react";
import { ChipProps } from "../../service/interfaces/Components";



const CustomChip: React.FC<ChipProps> = ({
  text,
  textColor = "#FF973C", // Default text color
  backgroundColor = "", // Default background color
  borderColor = "#FF973C", // Default border color
  className = "", // Allow custom additional classes
}) => {
  return (
    <div
      className={`px-2 flex items-center h-[22px] text-xs font-medium rounded-full border-[2px] ${className}`}
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        borderColor: borderColor,
      }}
    >
      {text}
    </div>
  );
};

export default CustomChip;
